module.exports = __webpack_public_path__ + "media/images/vp/icon.menu.help2.black-ef8e529eb4b56b685968e35200cddeae.svg";